import React, { useRef, useEffect, useState } from 'react';
import { FileText } from 'lucide-react';
import { markdownToHtml } from './markdownToHtml';

const StreamingContent = ({ content, isStreaming = false, messageId, onSourceClick }) => {
  const contentRef = useRef(null);
  const [renderedHtml, setRenderedHtml] = useState('');

  useEffect(() => {
    if (!isStreaming) {
      const cleaned = stripInlineSourceCitations(content || '');
      setRenderedHtml(markdownToHtml(cleaned));
    }
  }, [content, isStreaming]);

  // Strip [Source: filename] from content before markdown render
  // (they are shown separately in the sources panel)
  function stripInlineSourceCitations(text) {
    return text.replace(/\[Source:\s*[^\]]+\]/g, '').trim();
  }

  // For streaming: render inline source badges mixed into plain text
  const renderTextWithSources = (text) => {
    if (!text || !onSourceClick) return text;
    const sourcePattern = /\[Source:\s*([^\]]+)\]/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    let keyIndex = 0;
    while ((match = sourcePattern.exec(text)) !== null) {
      if (match.index > lastIndex) parts.push(text.slice(lastIndex, match.index));
      const filename = match[1].trim();
      parts.push(
        <button
          key={`source-${keyIndex++}`}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); onSourceClick(filename); }}
          className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#fffdf0] hover:bg-ugmonk-yellow/20 text-black rounded text-sm font-medium transition-colors cursor-pointer mx-1"
          title={`Click to preview ${filename}`}
        >
          <FileText className="w-3 h-3" />
          {filename}
        </button>
      );
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < text.length) parts.push(text.slice(lastIndex));
    return parts.length > 1 ? parts : text;
  };

  if (isStreaming) {
    return (
      <div className="text-gray-800 text-sm leading-relaxed whitespace-pre-wrap">
        <span ref={contentRef}>{renderTextWithSources(content)}</span>
        <span className="inline-block w-2 h-5 bg-ugmonk-yellow ml-1 animate-pulse align-middle" />
      </div>
    );
  }

  return (
    <div
      className="text-sm"
      dangerouslySetInnerHTML={{ __html: renderedHtml }}
    />
  );
};

export default StreamingContent;
